import React, { useEffect, useState } from 'react';
import { Table, Button, Row, Col, Tooltip, notification, Select } from 'antd';
import { FaPlusCircle, FaPencilAlt } from "react-icons/fa";
import { addSet, updateSet, getAllSet, getSet } from '../services/SetService';
import { getAllPlants } from '../services/PlantsService';
import { getActiveCategories } from '../services/CategoriesService';

import SetModalNew from './SetModalNew';
import SetModalEdit from './SetModalEdit';

const { Option } = Select;

function Sets(){
  const[dataSets, setDataSets] = useState([]);
  const[modalVisibleNew, setModalVisibleNew] = useState(false);
  const[modalVisibleEdit, setModalVisibleEdit] = useState(false);
  const[nameSet, setNameSet] = useState("");
  const[idSet, setIdSet] = useState("");
  const[tableSetsLoading, setTableSetsLoading] = useState(false);
  const[products, setProducts] = useState([]);
  const[dataPlantsStorage, setDataPlantsStorage] = useState([]);
  const[plantId, setPlantId] = useState("S");
  const[dataCategories, setDataCategories] = useState([]);


    useEffect(() => {
        async function process(){
          setTableSetsLoading(true);
          const { data } = await getAllSet();
          setDataSets(data);
          setTableSetsLoading(false);
        }
        async function plantsStorage(){
            const { data } = await getAllPlants();
            setDataPlantsStorage(data);
            setPlantId(data[0].id);
        }
        async function categories(){
            const { data } = await getActiveCategories();
            setDataCategories(data);
        }
        process();
        plantsStorage();
        categories();
        
    },[])

    const msNotification = (type, title, desc) => {
      notification[type]({
        message: title,
        description:
          desc,
      });
    };

    const handleClickModalNew = () => {
      setModalVisibleNew(true);
    }

    const handleClickModalEdit = (record) => {
      setNameSet(record.name);
      setIdSet(record.id);
      async function getDataSet(){
        const { data } = await getSet(record.id);
        const dataP = [...data.products];
        data.products.map(function(obj, index){
            let prod = dataCategories.filter(x => x.id === obj.categoryId);
            if(prod.length > 0){
                dataP[index].category = prod[0].name;
            }
            return true;
        });
        setProducts(dataP);
        setModalVisibleEdit(true);
        
      }
      getDataSet();
    }

    const handleOkModalNew = (nombre, products) =>{
      const request = {
        "PlantId": plantId,
        "Name": nombre,
        "Active": true,
        "Products": products
        
      };
      async function addNewSet(){
          try {
              const { data } = await addSet(request);
              const temp = [...dataSets];
              temp.push(data);
              setDataSets(temp);
              msNotification('success', 'Paquetes', 'Se creó el paquete.' );
          } catch (error) {
            msNotification('error', 'Paquetes', 'Error al crear el paquete.' );
          } finally {
            setModalVisibleNew(false);
          }
      }
      addNewSet();

    }

    const handleCancelModalNew = () =>{
      setModalVisibleNew(false);
    }

    const handleOkModalEdit = (nombre, products) =>{
        const request = {
            "PlantId": plantId,
            "Name": nombre,
            "Active": true,
            "Products": products
            
          };
      
      async function updateTheSet(){
          try {
              await updateSet(idSet, request);   
              const temp = [...dataSets]
              temp.find(x => x.id === idSet).name = nombre;
              setDataSets(temp); 
              msNotification('success', 'Paquete', 'Se actualizó el paquete.' );
          } catch (error) {
            msNotification('error', 'Paquete', 'Error al actualizar el paquete.' );
          } finally {
            setModalVisibleEdit(false);
          }
      }
      updateTheSet();      
      
    }

    const handleCancelModalEdit = () =>{
      setModalVisibleEdit(false);
    }

    function handleChangePlant(value) {
        setPlantId(value);
        if(value !== "S"){
            setTableSetsLoading(true);
            
            const data = dataSets.find(x => x.id === value);
            if(data === undefined){
            }else{
            }
            //console.log(data.products)
            // data.storageLocations.map(function(obj){
            //     const row = {
            //         id: obj.id,
            //         storageLocationId: obj.id,
            //         almacen: obj.name,
            //         stock: 0,
            //         safeStock: 0
            //     };
            //     const ps = dataProductStorage.filter(p => p.storageLocationId == obj.id);
            //     if(ps.length > 0){
            //         row.stock = ps.stock;
            //         row.safeStock = ps.safeStock;
            //     }
            //     dataStorage.push(row);
            // });
            //setDataTable(dataStorage);
            setTableSetsLoading(false);
        }
        
    }

    const columns = [
      {
        title: "Información",
        render: (record) => (
          <React.Fragment>
            {record.id}
            <br />
            {record.name}
          </React.Fragment>
        ),
        responsive: ["xs"]
      },
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        responsive: ["sm"]
      },
      {
        title: 'Nombre',
        dataIndex: 'name',
        key: 'name',
        responsive: ["sm"]
      },
      {
        title: '',
        align: 'center',
        render: (value, record) => (<Tooltip title="Editar">
            <Button type="primary" shape="circle" onClick={() => handleClickModalEdit(record)} icon={<FaPencilAlt />} />
          </Tooltip>)
      },
    ];

    return(
        <div className="mainContainer">

            <SetModalNew modalVisibleNew={modalVisibleNew} 
              handleCancelModalNew={handleCancelModalNew}
              handleOkModalNew={handleOkModalNew}
              dataCategories={dataCategories}/>

            <SetModalEdit modalVisibleEdit={modalVisibleEdit} 
              handleCancelModalEdit={handleCancelModalEdit}
              handleOkModalEdit={handleOkModalEdit}
              dataCategories={dataCategories}
              dataPaquete={products}
              name={nameSet}/>

            <Row>
                <Col span={24}>
                    <h1 className="title">Paquetes</h1>
                    <hr className="hr-title"/>
                </Col>
            </Row>

            <Row className="detailContainer">
                <Col span={24}>
                    <div className="divRight">
                        <Button type="primary" icon={<FaPlusCircle/>} onClick={handleClickModalNew}>
                          &nbsp; Nuevo
                        </Button>
                    </div>
                </Col>
                
                <Col span={8}>
                    <Select defaultValue="S" value={plantId} style={{ width: '100%', display:"none" }} onChange={handleChangePlant}>
                        <Option value="S">Selecciona una planta</Option>
                        {dataPlantsStorage.map(function(obj){
                            return <Option key={obj.id} value={obj.unit}>{obj.name}</Option>
                        })}
                    </Select>
                </Col>
                
                <Col span={24}>
                    <br/>
                    <Table rowKey="id" dataSource={dataSets} columns={columns} loading={tableSetsLoading}/>
                </Col>
            </Row>

        </div>
    );
}

export default Sets;



// WEBPACK FOOTER //
// ./src/components/Sets.jsx